/* eslint-disable @typescript-eslint/no-explicit-any */
import { takeLatest } from 'redux-saga/effects';

import * as commonSagas from '../_common/commonSagas';
import * as contractsSlice from './contractsSlice';

export default function* watchContractsSaga() {
 yield takeLatest(contractsSlice.getTableStart.type, commonSagas.getTable);
 yield takeLatest(contractsSlice.getItemStart.type, commonSagas.getItem);
 yield takeLatest(contractsSlice.createItemStart.type, commonSagas.createItem);
 yield takeLatest(contractsSlice.updateItemStart.type, commonSagas.updateItem);
 yield takeLatest(
  contractsSlice.deleteItemsStart.type,
  commonSagas.deleteItems,
 );
 yield takeLatest(contractsSlice.deleteItemStart.type, commonSagas.deleteItem);
 yield takeLatest(
  contractsSlice.getTableStructureStart.type,
  commonSagas.getTableStructure,
 );
 yield takeLatest(
  contractsSlice.getItemDocumentsStart.type,
  commonSagas.getItemDocuments,
 );
 yield takeLatest(
  contractsSlice.uploadItemDocumentsStart.type,
  commonSagas.uploadItemDocuments,
 );
 yield takeLatest(
  contractsSlice.deleteItemDocumentStart.type,
  commonSagas.deleteItemDocument,
 );
 yield takeLatest(
  contractsSlice.getTableExcelStart.type,
  commonSagas.getTableExcel,
 );
}
